import axios from "axios";
import { API_BASE, toV2ApiPath } from "../constants/api";
import { API } from "../constants/types";
import { fetchFailed, fetchRequested, fetchSucceeded } from "../actions/api";

const apiMiddleware = (store) => (next) => (action) => {
  if (next) next(action);

  const { type, payload } = action;

  const token = JSON.parse(localStorage.getItem("userData"));
  const handleheader = (data) => {
    if (data?.token) {
      return;
    } else if (token?.data?.authToken) {
      const authToken = `Bearer ${token?.data?.authToken}`;
      return { Authorization: `${token?.data?.authToken ? authToken : ""}` };
    }
  };

  if (type === API) {
    const {
      url,
      data,
      request = fetchRequested,
      success = fetchSucceeded,
      error = fetchFailed,
      method = "get",
      hideLoader,
      headers: extraHeaders,
      skipAuth,
    } = payload;
    if (!hideLoader) store.dispatch(request({ payload }));

    const headers = {
      ...(skipAuth ? {} : handleheader(data)),
      ...extraHeaders,
    };

    // Public endpoints must not send a leftover JWT from axios defaults.
    if (skipAuth) {
      headers.Authorization = false;
    }

    return axios({
      baseURL: API_BASE,
      method,
      url: toV2ApiPath(url),
      data,
      headers,
    })
      .then((res) => {
        store.dispatch(success(res.data));
        store.dispatch(fetchSucceeded());
        return Promise.resolve(res.data);
      })
      .catch((err) => {
        const errorData = err?.response?.data || {
          message: "Something went wrong, Please try again later!!!",
        };
        store.dispatch(error(errorData));
        store.dispatch(fetchFailed());
        return Promise.reject(errorData);
      });
  }
};

export default apiMiddleware;
